function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, RefObject, CSSProperties } from 'react';
import cn from 'classnames';
import { ITabBarButtonProps as ITabBarButtonInitialProps, TabBarButton } from './Button/TabBar-Button';
require("./TabBar.css");
var styles = {
  "Root": "TabBar-module-Root_Zal"
};
export const cnTabBar = cn('TabBar');
export const TabBar = ({
  buttons = [],
  activeButton,
  innerRef,
  className,
  style = {},
  ...props
}) => /*#__PURE__*/React.createElement("div", _extends({
  ref: innerRef,
  className: cn(styles.Root, className),
  style: style
}, props), buttons.map((buttonProps, index) => /*#__PURE__*/React.createElement(TabBarButton, _extends({
  key: buttonProps.text,
  isActive: index === activeButton
}, buttonProps))));
if (process.env.NODE_ENV !== 'production') {
  TabBar.displayName = 'TabBar';
}